module.exports = __webpack_public_path__ + "static/media/ICBT 3b.8dde3bc1.jpg";